module.exports = __webpack_public_path__ + "5c112b5b742a8afcbcc1df7e708b4260.pdf";